// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationResultUpdateRequest {
    'mock'?: boolean;
    'transactionCorrelationId': string;
    'externalId'?: string | null;
    'paStatus': string;
    'paMessage'?: string | null;
    'paStatusDateTime': string;
    'ssoUrl'?: string | null;
    'notificationSso'?: string | null;
    'providerPIN'?: string | null;
    'paDueDate'?: string | null;
    'paAuthorizationNumber'?: string | null;
    'authExpirationDate'?: string | null;
    'authStartDate'?: string | null;
    'transactionId'?: string | null;
    'transactionMessage'?: string | null;
    'ndc'?: string | null;
    'daysSupply'?: string | null;
    'quantity'?: string | null;
    'formTitle'?: string | null;
    'faxedDate'?: string | null;
    'emailedDate'?: string | null;
    'firstLoginDate'?: string | null;
    'startedByHcp'?: string | null;
    'communicationDate'?: string | null;
    'communicationType'?: string | null;
    'communicationStatus'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationResultUpdateRequest>> = [
        {
            "name":     "mock",
            "baseName": "mock",
            "type":     "boolean"
        },
        {
            "name":     "transactionCorrelationId",
            "baseName": "transactionCorrelationId",
            "type":     "string"
        },
        {
            "name":     "externalId",
            "baseName": "externalId",
            "type":     "string"
        },
        {
            "name":     "paStatus",
            "baseName": "paStatus",
            "type":     "string"
        },
        {
            "name":     "paMessage",
            "baseName": "paMessage",
            "type":     "string"
        },
        {
            "name":     "paStatusDateTime",
            "baseName": "paStatusDateTime",
            "type":     "string"
        },
        {
            "name":     "ssoUrl",
            "baseName": "ssoUrl",
            "type":     "string"
        },
        {
            "name":     "notificationSso",
            "baseName": "notificationSso",
            "type":     "string"
        },
        {
            "name":     "providerPIN",
            "baseName": "providerPIN",
            "type":     "string"
        },
        {
            "name":     "paDueDate",
            "baseName": "paDueDate",
            "type":     "string"
        },
        {
            "name":     "paAuthorizationNumber",
            "baseName": "paAuthorizationNumber",
            "type":     "string"
        },
        {
            "name":     "authExpirationDate",
            "baseName": "authExpirationDate",
            "type":     "string"
        },
        {
            "name":     "authStartDate",
            "baseName": "authStartDate",
            "type":     "string"
        },
        {
            "name":     "transactionId",
            "baseName": "transactionId",
            "type":     "string"
        },
        {
            "name":     "transactionMessage",
            "baseName": "transactionMessage",
            "type":     "string"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
        {
            "name":     "daysSupply",
            "baseName": "daysSupply",
            "type":     "string"
        },
        {
            "name":     "quantity",
            "baseName": "quantity",
            "type":     "string"
        },
        {
            "name":     "formTitle",
            "baseName": "formTitle",
            "type":     "string"
        },
        {
            "name":     "faxedDate",
            "baseName": "faxedDate",
            "type":     "string"
        },
        {
            "name":     "emailedDate",
            "baseName": "emailedDate",
            "type":     "string"
        },
        {
            "name":     "firstLoginDate",
            "baseName": "firstLoginDate",
            "type":     "string"
        },
        {
            "name":     "startedByHcp",
            "baseName": "startedByHcp",
            "type":     "string"
        },
        {
            "name":     "communicationDate",
            "baseName": "communicationDate",
            "type":     "string"
        },
        {
            "name":     "communicationType",
            "baseName": "communicationType",
            "type":     "string"
        },
        {
            "name":     "communicationStatus",
            "baseName": "communicationStatus",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationResultUpdateRequest.attributeTypeMap;
    }
}
